import React from 'react';
import { IconContainer } from './IconContainer';

const ArrowFilledIcon = ({ rotate, ...props}) => {
    return (
        <IconContainer ariaLabel="arrow-filled" rotate={rotate} {...props}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 12L14 6V18L8 12Z"></path>
            </svg>
        </IconContainer>
    )
}

export { ArrowFilledIcon };